import {
	getSalesCartItems,
	getSalesCartRewardBalanceMe,
	getSalesCartRewardThresholdMe,
	getSalesCheckoutCoupon,
	getSalesCheckoutGiftCardsData,
	getSalesCheckoutGiftOptions,
} from 'data-api'
import { useCallback } from 'react'
import { useConfig } from '../../providers/config'
import { useUser } from '../../providers/user'
import { useApiMutate } from '../useApiMutate'

export const useCartMutate = () => {
	const [{ isLoggedIn }] = useUser()
	const {
		rewardPoints: { enabled: rewardPointsEnabled, enablePoints: pointsEnabled },
		sales: {
			giftCards: { enabled: giftCardsEnabled },
			giftOptions: {
				giftMessage: { enabled: giftMessageEnabled },
				giftWrap: { enabled: giftWrapEnabled },
			},
			coupon: { disabled: couponDisabled },
		},
	} = useConfig()

	const mutateCart = useApiMutate({ method: getSalesCartItems })
	const mutateCoupon = useApiMutate({ method: getSalesCheckoutCoupon })
	// thresholds: need to change when the cart is updated
	const mutateCartThresholds = useApiMutate({ method: getSalesCartRewardThresholdMe })
	// earning points: need to change when cart items are added or removed
	const mutateEarningPoints = useApiMutate({ method: getSalesCartRewardBalanceMe })
	const mutateGiftCards = useApiMutate({ method: getSalesCheckoutGiftCardsData })
	const mutateGiftOptions = useApiMutate({ method: getSalesCheckoutGiftOptions })

	/**
	 * Mutate all cart data
	 * @param {Object} mutateArgs - Arguments to pass to mutateCart
	 */
	const mutate = useCallback(
		async (...mutateArgs) => {
			const results = await mutateCart(...mutateArgs)
			const mutations = []

			if (!couponDisabled) {
				mutations.push(mutateCoupon)
			}

			if (isLoggedIn && rewardPointsEnabled && pointsEnabled) {
				mutations.push(mutateCartThresholds)
				mutations.push(mutateEarningPoints)
			}

			if (giftCardsEnabled) {
				mutations.push(mutateGiftCards)
			}

			if (giftMessageEnabled || giftWrapEnabled) {
				mutations.push(mutateGiftOptions)
			}

			mutations.forEach((fn) => fn())

			return results
		},
		[
			couponDisabled,
			giftCardsEnabled,
			giftMessageEnabled,
			giftWrapEnabled,
			isLoggedIn,
			mutateCart,
			mutateCartThresholds,
			mutateCoupon,
			mutateEarningPoints,
			mutateGiftCards,
			mutateGiftOptions,
			pointsEnabled,
			rewardPointsEnabled,
		]
	)

	return mutate
}
